<template>
  <a-form-item
    :label="title"
    :required="this.image.switch"
  >
    <small>Kategorie má obrázek:&nbsp;</small>
    <a-switch checkedChildren="Ano" unCheckedChildren="Ne" v-model="image.switch"
              @change="onImageSwitchChange"/>
    <div v-if="this.image.switch">
      <a-row class="pb-5" type="flex" justify="center">
        <a-col :span="8">
          <a-input-search
            placeholder="Hledat..."
            v-model="image.search"
          />
        </a-col>
      </a-row>
      <div v-if="images.data.length > 0">
        <a-row>
          <a-radio-group
            v-decorator="[decoratorName, {required: this.image.switch, message: 'Obrázek musí být vyplněn!'}]"
            name="image" :class="$style.gallery">
            <a-col :key="index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
              <div
                :class="{[$style.active]: item.iae_id === form.getFieldValue(decoratorName), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid"
                     v-lazy="$uploadImagePath + item.iae_path + (item.is_breadcrumb ? '_bc.' : '_6.') + item.iae_format"
                     @error="image.errors.push(item.iae_id)">
                <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown"/>
                <div :class="$style.itemControls">
                  <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                  <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id"/>
                </div>
              </div>
            </a-col>
          </a-radio-group>
        </a-row>
        <a-row class="pb-5 pt-5" type="flex" justify="center">
          <a-col :span="8">
            <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto"
                      @click="onNextImagesClick">Načíst dalších {{ imageNextCount }}...
            </a-button>
          </a-col>
        </a-row>
      </div>
      <a-empty v-else>
        <a-spin v-if="!image.loaded"/>
      </a-empty>
    </div>
  </a-form-item>
</template>

<script>
import imageMixins from '@/components/MyComponents/Gallery/image-mixins'

export default {
  name: 'my-form-image-item',
  mixins: [imageMixins],
  props: {
    title: String,
    image: Object,
    images: Object,
    imageNextCount: Number,
    onNextImagesClick: Function,
    onImageSwitchChange: Function,
    decoratorName: String,
    form: Object,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
